import React from 'react';
import EventHistoryPanel from '../EventHistoryPanel';
import RequestDetailCard from '../requests/RequestDetailCard';

function OperationalRequestDetail({
  emptyMessage,
  footer = null,
  historyRefreshKey = 0,
  historyTitle = 'Request History',
  onOpenPersonWorkspace = null,
  request,
  requestContext = null,
  requestTitle = 'Selected Request'
}) {
  return (
    <div className="role-request-detail">
      <RequestDetailCard
        request={request}
        title={requestTitle}
        emptyMessage={emptyMessage}
        footer={footer}
        onOpenPersonWorkspace={onOpenPersonWorkspace}
      />
      <EventHistoryPanel
        eventId={request?.id}
        refreshKey={historyRefreshKey}
        title={historyTitle}
        requestContext={requestContext}
      />
    </div>
  );
}

export default OperationalRequestDetail;
